import React from 'react';

export default function RecoveryComplete(nextStep) {
	const changeStep = () => {
		nextStep.nextStep(1);
	};
	return (
		<div>
			<h3 className='lkLogin-main__step'>пароль изменён</h3>
			<h1 className='lkLogin-main__title'>Вы у цели</h1>
			<button onClick={changeStep} className='lkLogin-form-btn lkLogin-form-item'>
				Войти
			</button>
		</div>
	);
}
